import { AppCodes, MenuItemCategory, MenuItemType, NavObjectType, PopupPageId } from '../Components/navigationTypes';
import { Nav, Navbar, Tab, ListGroup } from 'react-bootstrap'
import { useEffect, useRef, useState } from "react";
import { RPWDataReader, getDataReader } from '../livedataFuncs'
import { navItem } from './navigationElement';
import { FileTabButton } from './fileTabButton';
import { CONST, ContractType, fileTabVal, FinanceType, MortgageType, PersonType, PurchaserType, RegistrationType } from './sideTypes';
import { getDetailsList } from './menus/details';
import { workspaceList } from './menus/workspace';
import { documentsList } from './menus/documents';
import { clientPortalList } from './menus/clientportal';
import { store } from '../redux/store';
import { useAppSelector } from '../redux/hooks';
import { lddStateObject } from '../redux/reducer';
import React from 'react';
import './sidedrawer.css'
import EventQueueManager from '../lib/eventQueue';

async function currentPageMenu(props: { page: NavObjectType, dataroot: any, filetab: fileTabVal }): Promise<Array<MenuItemType>> {
    const page: NavObjectType = props.page;
    let fileList = [];
    const appCodeShort = store?.getState()?.SessionInfo?.appProvinceShort;
    const appCode = store?.getState()?.SessionInfo?.appCode;
    const sid = store?.getState()?.SessionInfo?.sid;
    const processor: RPWDataReader = getDataReader(props.dataroot);

    switch (props.filetab) {
        case fileTabVal.DETAILS:
            fileList = await getDetailsList(appCodeShort, sid);
            break;
        case fileTabVal.WORKSPACE:
            fileList = workspaceList;
            break;
        case fileTabVal.DOCUMENTS:
            fileList = documentsList;
            break;
        case fileTabVal.CLIENTPORTAL:
            fileList = clientPortalList();
            break;
        default:
            fileList = [];
            break;
    }

    let menu: Array<MenuItemType> = [];
    let ProperMenu: Array<MenuItemType> = [];
    let PSM: string;
    if (typeof page.url === "string") {
        if (page.url?.indexOf("appEditDispatch") > -1 && page.params?.PSM && page.params?.PSM.length > 0) {
            menu = menu.concat(initMenu(newFileMenu(fileList), page.params))
        }
        if (page.params && page.params['formasp'] === 'purfileedit') {
            let id: string;
            if (props.dataroot) {
                if (props.dataroot.selectSingleNode("ancestor-or-self::TPAppXML") !== undefined) {
                    id = props.dataroot.selectSingleNode("ancestor-or-self::TPAppXML").getAttribute("AppID");
                } else {
                    id = page.params.id
                }
            } else {
                id = page.params.id
            }
            menu = menu.concat(newFileMenu(fileList))
            if (props.dataroot) {
                PSM = processor.getPSM();
                switch (props.filetab) {
                    case fileTabVal.DETAILS:
                        loadDetailsMenu(processor, menu, ProperMenu, id);
                        break;
                    case fileTabVal.WORKSPACE:
                        loadWorkspaceMenu(processor, menu, ProperMenu);
                        break;
                    case fileTabVal.DOCUMENTS:
                        ProperMenu = menu;
                        break;
                    case fileTabVal.CLIENTPORTAL:
                        loadClientPortalMenu(menu, ProperMenu);
                        break;
                    default:
                        fileList = [];
                        break;
                }
            } else {
                return []
            }
            menu = initMenu(menu, { id: id, ...page.params })
            ProperMenu = initMenu(ProperMenu, { id: id, ...page.params })
        }

    }
    let returnMenu = filterAllMenuItemsNoMap(PSM, ProperMenu, validatePSM);
    returnMenu = filterAllMenuItems(appCode, returnMenu, validateAppCode)
    if (PSM) {
        returnMenu = filterAllMenuItems(PSM, returnMenu, validatePSM);
    }
    returnMenu = filterAllMenuItems(processor, returnMenu, validateRequiredFields);
    return returnMenu
}

function loadClientPortalMenu(menu: Array<MenuItemType>, ProperMenu: Array<MenuItemType>) {
    const clientConnect = menu.find(menuItem => menuItem.label === "ClientConnect");
    const remoteClosing = menu.find(menuItem => menuItem.label === "E-Signing");
    ProperMenu.push(clientConnect);

    const clientTasks = menu.find(menuItem => menuItem.label === "Client Tasks");
    ProperMenu.push(clientTasks);

    ProperMenu.push(remoteClosing);
}

function findMenuItem(menu: Array<MenuItemType>, name: string): MenuItemType {
    return menu.find(menuItem => menuItem.label === name);
}

function loadWorkspaceMenu(processor: RPWDataReader, menu: Array<MenuItemType>, ProperMenu: Array<MenuItemType>): void {
    let PSM = processor.getPSM();
    const diligence = menu.find(menuItem => menuItem.label === "Due Diligence")
    if (diligence) {
        /*const titleSearch = findMenuItem(diligence.subItems, "Title Search")
        const writSearch = findMenuItem(diligence.subItems, "Writ Search");
        const titleSearchData: Array<TitleSearchType> = processor.getTitleSearch()
        const writSearchData: Array<TitleSearchType> = processor.getTitleSearch()
        if (titleSearchData.length > 0) {
            titleSearch.params = { badgetext: drawerDateFormat(titleSearchData[0].date), badgetype: "active" };
        } else {
            titleSearch.params = { badgetext: "None", badgetype: "fail" };
        }
        if (writSearchData.length > 0) {
            writSearch.params = { badgetext: drawerDateFormat(writSearchData[0].date), badgetype: "active" };
        } else {
            writSearch.params = { badgetext: "None", badgetype: "fail" };
        }*/
        ProperMenu.push(diligence);
    }
    const titleInsuranceHeader = findMenuItem(menu, "Title Insurance");
    const titleSubItem = titleInsuranceHeader.subItems.find(menuItem => menuItem.type === MenuItemCategory.TitleInsurance);
    if (titleSubItem && validatePSM(PSM, titleInsuranceHeader)) {
        let titleInsuranceLabel = processor.getInsuranceInformation().insuranceProvider;
        if (titleInsuranceLabel && titleInsuranceLabel.length > 0) {
            titleSubItem.label = titleInsuranceLabel;
        } else {
            titleSubItem.label = "+ Title Insurance";
        }
        ProperMenu.push(titleInsuranceHeader);
    }
    const matterHeader = menu.find(menuItem => menuItem.id === "Matters")
    if (matterHeader) {
        loadMatterInfo(processor.getDefectInformation(), matterHeader);
        ProperMenu.push(matterHeader);
    }

    const requisitionHeader = menu.find(menuItem => menuItem.id === "Requisition")
    if (requisitionHeader) {
        loadMatterInfo(processor.getDefectInformation(), requisitionHeader);
        ProperMenu.push(requisitionHeader);
    }

    const objectionHeader = menu.find(menuItem => menuItem.id === "Objection")
    if (objectionHeader) {
        loadMatterInfo(processor.getDefectInformation(), objectionHeader);
        ProperMenu.push(objectionHeader);
    }

    const trustLetterMBHeader = menu.find(menuItem => menuItem.id === "TrustLetterMB")
    if (trustLetterMBHeader) {
        loadMatterInfo(processor.getDefectInformation(), trustLetterMBHeader);
        ProperMenu.push(trustLetterMBHeader);
    }

    const trustLetterSKHeader = menu.find(menuItem => menuItem.id === "TrustLetterSK")
    if (trustLetterSKHeader) {
        loadMatterInfo(processor.getDefectInformation(), trustLetterSKHeader);
        ProperMenu.push(trustLetterSKHeader);
    }

    const trustLetterHeader = menu.find(menuItem => menuItem.id === "TrustLetter")
    if (trustLetterHeader) {
        loadMatterInfo(processor.getDefectInformation(), trustLetterHeader);
        ProperMenu.push(trustLetterHeader);
    }

    const descriptionHeader = menu.find(menuItem => menuItem.id === "Description")
    if (descriptionHeader) {
        loadMatterInfo(processor.getDefectInformation(), descriptionHeader);
        ProperMenu.push(descriptionHeader);
    }

    const titleMemorandumResponseHeader = menu.find(menuItem => menuItem.id === "TitleMemorandum")
    if (titleMemorandumResponseHeader) {
        loadMatterInfo(processor.getDefectInformation(), titleMemorandumResponseHeader);
        ProperMenu.push(titleMemorandumResponseHeader);
    }

    const undertakingResponseHeader = menu.find(menuItem => menuItem.id === "Undertaking")
    if (undertakingResponseHeader) {
        loadMatterInfo(processor.getDefectInformation(), undertakingResponseHeader);
        ProperMenu.push(undertakingResponseHeader);
    }

    const IssuesHeader = menu.find(menuItem => menuItem.id === "Issues")
    if (IssuesHeader && validatePSM(PSM, IssuesHeader)) {
        var issueSubItems = IssuesHeader.subItems;
        let newSubItems: Array<MenuItemType> = [];
        for (let i = 0; i < issueSubItems.length; i++) {
            let s = issueSubItems[i];
            if (validatePSM(PSM, s)) {
                newSubItems.push(s);
            }
        }
        IssuesHeader.subItems = newSubItems;
        ProperMenu.push(IssuesHeader);
    }

    const registration = menu.find(menuItem => menuItem.label === "Registration")
    if (registration) {
        let newSubItems: Array<MenuItemType> = processor.getRegistrationDetails().map(displayDefect);
        for (let i = 0; i < newSubItems.length; i++) {
            let s = newSubItems[i];
            registration.subItems.push(s);
        }
        ProperMenu.push(registration);
    }
}
function filterAllMenuItemsNoMap(checkParam: any, menu: Array<MenuItemType>, condition: (param: any, menuItem: MenuItemType) => Boolean) {
    return menu
        .filter((menuItem) => condition(checkParam, menuItem))
}
function filterAllMenuItems(checkParam: any, menu: Array<MenuItemType>, condition: (param: any, menuItem: MenuItemType) => Boolean): Array<MenuItemType> {
    return menu
        .filter((menuItem) => condition(checkParam, menuItem))
        .map((menuItem) => filterMenuItem(checkParam, menuItem, condition));
}
function filterMenuItem(checkParam: any, def: MenuItemType, condition: (param: any, menuItem: MenuItemType) => Boolean): MenuItemType {
    if (def.subItems) {
        def.subItems = filterAllMenuItems(checkParam, def.subItems, condition)
    }
    if (def.addOptions) {
        def.addOptions = filterAllMenuItems(checkParam, def.addOptions, condition)
    }
    return def
}
function validateAppCode(currApp: AppCodes, def: MenuItemType): boolean {
    let ret = true;
    let condition = def.appCode;
    if (condition) {
        ret = false;
        for (let i = 0; i < condition.length; i++) {
            if (condition[i].toUpperCase() === currApp.toUpperCase()) {
                ret = true;
            }
        }
    }
    return ret;
}
function validatePSM(fileType, def: MenuItemType): boolean {
    let ret = true;
    let condition = def.PSM;
    if (condition) {
        ret = false;
        for (let i = 0; i < condition.length; i++) {
            let c = condition.charAt(i);
            if (c.toUpperCase() === fileType.toUpperCase()) {
                ret = true;
            }
        }
    }
    return ret;
}
function validateRequiredFields(processor: RPWDataReader, def: MenuItemType): boolean {
    let ret = true;
    const condition = def.requiredFields;
    if (condition) {
        ret = false;
        for (let i = 0; i < condition.length; i++) {
            const value = processor[condition[i].field]();
            if (condition[i].value) {
                ret = value === condition[i].value;
            } else if (value) {
                ret = true;
            }
        }
    }
    return ret;
}

export const SolicitorNavigate: NavObjectType = {
    component: "main",
    url: "lfmaster.asp",
    params: {
        "tb": "TPAppXML",
        "formasp": "purfileedit",
        "id": CONST.uninitialized,
        "PSM": CONST.uninitialized,
    },
    controller: {
        tabName: PopupPageId.Solicitor,
    },
}

function loadDetailsMenu(processor: RPWDataReader, menu: Array<MenuItemType>, ProperMenu: Array<MenuItemType>, id: string): void {
    let buyerHeader = menu.find(menuItem => menuItem.id === "Buyer");
    let PSM = processor.getPSM();
    let contractHeader = menu.find(menuItem => menuItem.label === "Contract")
    if (contractHeader && validatePSM(PSM, contractHeader)) {
        let c = updateContract(processor, processor.getContractInformation(), contractHeader)
        ProperMenu.push(c);
    }
    var otherSideLawyer = processor.getOtherSideLawyerName();
    const newSolicitor: MenuItemType = {
        type: MenuItemCategory.Blank,
        label: 'othersidelawyer',
        navigate: { component: 'main' },
        addOptions: [],
        subItems: [
            {
                label: (otherSideLawyer > "") ? processor.getOtherSideLawyerName() : '+ Lawyer',
                navigate: structuredClone(SolicitorNavigate),
                params: {
                    badgetext: processor.getOtherSideLawyerBadge(),
                },
                addOptions: [],
                type: MenuItemCategory.LawyerList,
            }
        ]
    }
    if (buyerHeader) {
        if (PSM === "M") {
            buyerHeader.label = "Borrower Side";
            const buyerInfo = processor.getMortgagorInformation();
            buyerHeader.subItems = buyerInfo.map((val, index) => displayPurchaser(val, index, buyerInfo.length));
        } else {
            const buyerInfo = processor.getBuyerPeopleInfo();
            buyerHeader.subItems = buyerInfo.map((val, index) => displayPurchaser(val, index, buyerInfo.length));
        }
        const length = buyerHeader.subItems.length;
        buyerHeader.addOptions.forEach((menuElement: MenuItemType) => { menuElement.navigate.controller.tabNumber = length + 1 });
    }
    let sellerHeader = menu.find(menuItem => menuItem.id === "Seller")
    if (sellerHeader && validatePSM(PSM, sellerHeader)) {
        const sellerInfo = processor.getVendorInformation();
        sellerHeader.subItems = sellerInfo.map((val, index) => displayVendor(val, index, sellerInfo.length))
        const length = sellerHeader.subItems.length;
        sellerHeader.addOptions.forEach((menuElement: MenuItemType) => { menuElement.navigate.controller.tabNumber = length + 1 })
    }
    if (PSM === "S") {
        if (sellerHeader) {
            ProperMenu.push(sellerHeader);
        }
        if (buyerHeader) {
            ProperMenu.push(buyerHeader);
        }
    } else {
        if (buyerHeader) {
            ProperMenu.push(buyerHeader);
        }
        if (sellerHeader) {
            ProperMenu.push(sellerHeader);
        }
    }
    ProperMenu.push(newSolicitor)
    let thirdParty = menu.find(menuItem => menuItem.id === "Third")
    if (thirdParty && validatePSM(PSM, thirdParty)) {
        const allThirdParty = processor.getThirdPartyInfo();
        const otherParties = allThirdParty.filter(node => ["OtherParty"].indexOf(node.personType) !== -1);
        const theRestParties = allThirdParty.filter(node => ["OtherParty"].indexOf(node.personType) === -1);
        const otherPartiesSubItems = otherParties.map((data, index) => { return displayPeople(data, index, processor); });
        const theRestPartiesSubItems = theRestParties.map((data, index) => { return displayPeople(data, index, processor); });
        thirdParty.subItems = [...theRestPartiesSubItems, ...otherPartiesSubItems];
        ProperMenu.push(thirdParty);
    }
    let mortgageHeader = menu.find(menuItem => menuItem.label === "Mortgage")
    if (mortgageHeader && validatePSM(PSM, mortgageHeader)) {
        const regMortgages = processor.getMortgageInformation();
        const mortgageSubItems = regMortgages.map((data, index) => { return displayMortgage(data, index, id, regMortgages.length); }).concat(
            processor.getDefectMortgages().map((data, index) => { return displayMortgage(data, index, id); })
        );
        mortgageHeader.subItems = mortgageSubItems;
        ProperMenu.push(mortgageHeader);
    }

    let IssuesHeader = menu.find(menuItem => menuItem.id === "Issues")
    if (IssuesHeader && validatePSM(PSM, IssuesHeader)) {
        var issueSubItems = IssuesHeader.subItems;
        let newSubItems: Array<MenuItemType> = [];
        for (let i = 0; i < issueSubItems.length; i++) {
            let s = issueSubItems[i];
            if (validatePSM(PSM, s)) {
                newSubItems.push(s);
            }
        }
        IssuesHeader.subItems = newSubItems;
        ProperMenu.push(IssuesHeader);
    }

    let financialHeader = menu.find(menuItem => menuItem.label === "Financial")
    if (financialHeader && validatePSM(PSM, financialHeader)) {
        updateFinancial(processor, processor.getFinancialInformation(), financialHeader);
        ProperMenu.push(financialHeader);
    }
}

function loadMatterInfo(matterInfo: Array<Record<string, string>>, matterHeader: MenuItemType) {
    let allMatters = matterHeader.subItems.find(matterSubItem => matterSubItem.label === "All");
    let outstandingMatters = matterHeader.subItems.find(matterSubItem => matterSubItem.label === "Outstanding");
    let resolvedMatters = matterHeader.subItems.find(matterSubItem => matterSubItem.label === "Resolved");
    var counters = {
        all: matterInfo.length,
        outstanding: 0,
        resolved: 0,
    }
    for (let matter of matterInfo) {
        if (matter.CheckResolved === '1') {
            counters.resolved += 1;
        } else {
            counters.outstanding += 1;
        }
    }
    if (allMatters)
        allMatters.params["counter"] = String(counters.all);
    if (outstandingMatters)
        outstandingMatters.params["counter"] = String(counters.outstanding);
    if (resolvedMatters)
        resolvedMatters.params["counter"] = String(counters.resolved);
}

function initMenu(menu: Array<MenuItemType>, params: Record<string, string>): Array<MenuItemType> {
    return menu.map(menuItem => initMenuItem(menuItem, params))
}

function initMenuItem(menuItem: MenuItemType, params: Record<string, string>): MenuItemType {
    if (menuItem?.navigate?.params?.id && menuItem.navigate.params.id === CONST.uninitialized) {
        menuItem.navigate.params.id = params.id
    }
    if (menuItem?.navigate?.params?.PSM && menuItem.navigate.params.PSM === CONST.uninitialized) {

        menuItem.navigate.params.PSM = params.PSM
    }
    if (menuItem.subItems) {
        menuItem.subItems = initMenu(menuItem.subItems, params);
    }
    if (menuItem.addOptions) {
        menuItem.addOptions = initMenu(menuItem.addOptions, params);
    }
    return menuItem;
}

const newFileMenu: ((list: Array<MenuItemType>) => Array<MenuItemType>) = (list) => structuredClone(list);

function displayMortgage(mortgage: MortgageType, index: number, appID: string, final?: number): MenuItemType {
    let navigation: NavObjectType;
    switch (mortgage.type) {
        case "Discharge":
            navigation = {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Issues",
                    tabNumber: 0,
                },
                action: "ReactShell.ReactEditExistingMortgage",
                actionParam: mortgage.position,
            }
            break;
        case "Assumed":
            navigation = {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": CONST.uninitialized,
                    "PSM": CONST.uninitialized,
                },
                controller: {
                    tabName: "Issues",
                    tabNumber: 0,
                },
                action: "ReactShell.ReactEditExistingMortgage",
                actionParam: mortgage.position,
            }
            break;
        case "Remaining":
            break;
        case "Postpone":
            break;
        default:
            navigation = {
                component: "main",
                url: "lfmaster.asp",
                params: {
                    "tb": "TPAppXML",
                    "formasp": "purfileedit",
                    "id": appID,
                    "PSM": mortgage.PSM,
                },
                controller: {
                    tabName: "Mortgages",
                    tabNumber: index + 1,
                },
            }
    }
    return {
        label: mortgage.Lender ? mortgage.Lender : "Select Lender",
        navigate: navigation,
        params: {
            badgetext: mortgage.type,
            badgeCategory: "Mortgage",
            final: String(typeof final === 'number' && index === final - 1),
        },
        addOptions: [],
        type: MenuItemCategory.Default,
    }
}
function displayPeople(person: PersonType, index: number, livedataRoot: RPWDataReader): MenuItemType {
    const personItem: MenuItemType = {
        label: person.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            controller: {
                tabName: PopupPageId[person.personType],
            },
        },
        params: {
            badgetext: ""
        },
        addOptions: [],
        type: MenuItemCategory.AdditionalParties
    };
    switch (person.personType) {
        case 'Conveyancer':
            personItem.params.badgetext = "Conveyancer";
            break;
        case 'InsuranceAgent':
            personItem.params.badgetext = "Fire Ins.";
            break;
        case 'MortgageBroker':
            personItem.params.badgetext = "Mortgage Broker";
            break;
        case 'PurchaserRealEstateAgent': {
            let t = "Realtor";
            const appcode = livedataRoot.getAppCode();
            if (appcode === "BC") {
                t = "S Agent";
            } else if (appcode === "NS" || appcode === "SK" || appcode === "MB") {
                t = "P. Realtor"
            }
            personItem.params.badgetext = t;
            break;
        }
        case 'RealEstateAgent': {
            let t = "Realtor";
            const appcode = livedataRoot.getAppCode();
            if (appcode === "BC") {
                t = "L Agent";
            } else if (appcode === "NS" || appcode === "SK" || appcode === "MB") {
                t = "V. Realtor"
            }
            personItem.params.badgetext = t;
            break;
        }
        case "OtherParty":
            switch (person.OtherPartyType) {
                case "Relocation Company":
                    personItem.params.badgetext = "Relocation Co.";
                    break;
                default:
                    personItem.params.badgetext = person.OtherPartyType.substring(0, 14);
                    break;
            }
            personItem.navigate.controller.tabNumber = index + 1;
            break;
    }
    return personItem;
}

function displayVendor(vendor: Record<string, string>, index: number, final?: number): MenuItemType {
    return {
        label: vendor.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            controller: {
                tabName: PopupPageId.Transferor,
                tabNumber: index + 1,
            },
            scrollToId: "contentHolder"
        },
        params: {
            agreement: vendor.IsVendor,
            title: vendor.OnTitle,
            final: String(typeof final === 'number' && index === final - 1),
        },
        addOptions: [],
        type: MenuItemCategory.Person
    }
}

function updateContract(processor: RPWDataReader, contract: ContractType, contractHeader: MenuItemType): MenuItemType {
    let PSM = processor.getPSM();
    let newSubItems: Array<MenuItemType> = [];
    let subItems = contractHeader.subItems;
    for (let i = 0; i < subItems.length; i++) {
        let s = subItems[i];
        if (validatePSM(PSM, s)) {
            newSubItems.push(s);
        }
    }

    contractHeader.subItems = newSubItems;
    return contractHeader
}

function updateFinancial(processor: RPWDataReader, finance: FinanceType, financeHeader: MenuItemType): MenuItemType {
    let PSM = processor.getPSM();
    let newSubItems: Array<MenuItemType> = [];
    let subItems = financeHeader.subItems;
    for (let i = 0; i < subItems.length; i++) {
        let s = subItems[i];
        if (validatePSM(PSM, s)) {
            newSubItems.push(s);
        }
    }
    financeHeader.subItems = newSubItems;
    return financeHeader
}

function displayPurchaser(purchaser: PurchaserType, index: number, final?: number): MenuItemType {
    return {
        label: purchaser.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
            params: {
                "tb": "TPAppXML",
                "formasp": "purfileedit",
                "id": CONST.uninitialized,
                "PSM": CONST.uninitialized,
            },
            controller: {
                tabName: PopupPageId.Transferee,
                tabNumber: index + 1,
            },
            scrollToId: "contentHolder"
        },
        params: {
            agreement: purchaser.IsPurchaser,
            title: purchaser.OnTitle,
            final: String(typeof final === 'number' && index === final - 1)
        },
        addOptions: [],
        type: MenuItemCategory.Person
    }
}

function displayDefect(defect: RegistrationType): MenuItemType {
    return {
        label: defect.Name,
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        addOptions: [],
        type: MenuItemCategory.Default,
    }
}



export const NavFileContainer = (props: {
    setDrawerState: (tab: fileTabVal) => void,
    drawerState: fileTabVal,
    page: NavObjectType,
}) => {
    const [betaUsers, setBetaUsers] = useState([]);
    const [menu, setMenu] = useState<Array<MenuItemType>>([]);
    const [queueManager] = useState<EventQueueManager>(() => new EventQueueManager());
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const sideMenuReload = useAppSelector((state) => state.SideMenuReload);
    const handleSetDrawer = (tab: fileTabVal) => {
        props.setDrawerState(tab);
    }

    useEffect(() => {
        const url = 'js/clientConnectBetaUsers.json';
        fetch(url, { method: 'GET', cache: "default" })
            .then((result) => {
                result.text().then((s) => {
                    setBetaUsers(JSON.parse(s).allowedFirms)
                }).catch(err => {
                    console.log('error', err)
                });
            })
            .catch(error => {
                console.log('error', error)
            });
    }, []);

    const [openMenu, setOpenMenu] = useState<Record<string, boolean>>({});
    const [defaultKey, setDefaultKey] = useState<string>(`${props.page?.controller?.tabName}-${props.page?.controller?.tabNumber}-${props.page?.actionParam}-Basic`);
    const drawerToggleMenu = (menuItem) => () => {
        const newOpenMenu = { ...openMenu };
        if (menuItem in openMenu) {
            newOpenMenu[menuItem] = !newOpenMenu[menuItem];
        } else {
            newOpenMenu[menuItem] = true;
        }
        setOpenMenu(newOpenMenu);
    }
    // useEffect - Load side menu
    useEffect(() => {
        const promise = () => new Promise((resolve, reject) => {
            currentPageMenu({ dataroot: livedataRootContainer?.dataRoot, page: props.page, filetab: props.drawerState })
            .then(pageMenu => {
                setMenu(pageMenu);
                if (pageMenu.length > 0) {
                    const label = props.page.label;
                    setDefaultKey(`${props.page?.controller?.tabName}-${props.page?.controller?.tabNumber}-${props.page?.actionParam}-${label}`);
                }
                resolve(true);
            })
            .catch(error => {
                reject(error);
            });
        });
        queueManager.enque(promise);
    }, [props.drawerState, livedataRootContainer, openMenu, sideMenuReload, props.page]);

    if (!(props.page.params && props.page.params['formasp'] === 'purfileedit')) {
        return (<></>)
    }
    let appAppCode = '';
    let appLawyerID = '';
    let appDataReader = null;
    if(livedataRootContainer?.dataRoot){
        appDataReader = getDataReader(livedataRootContainer.dataRoot);
        appLawyerID = appDataReader?.getLawyerId();
        appAppCode = appDataReader?.getAppCode();
    }
    return (
        menu.length > 0 &&
        <>
            <Navbar className="flex-column nav-file-tabs">
                <FileTabButton
                    setValue={fileTabVal.DETAILS}
                    setMenuState={handleSetDrawer}
                    stateValue={props.drawerState}
                    icon={"fa-chart-simple-horizontal"}
                    title={"Details"}
                />
                <FileTabButton
                    setValue={fileTabVal.WORKSPACE}
                    setMenuState={handleSetDrawer}
                    stateValue={props.drawerState}
                    icon={"fa-chart-tree-map"}
                    title={"Workspace"}
                />
                <FileTabButton
                    setValue={fileTabVal.DOCUMENTS}
                    setMenuState={handleSetDrawer}
                    stateValue={props.drawerState}
                    icon={"fa-memo-pad"}
                    title={"Documents"}
                />
                {
                    livedataRootContainer?.dataRoot &&
                    (betaUsers.indexOf(appLawyerID) !== -1 || betaUsers.indexOf(appAppCode) !== -1) &&
                    <FileTabButton
                        setValue={fileTabVal.CLIENTPORTAL}
                        setMenuState={handleSetDrawer}
                        stateValue={props.drawerState}
                        icon={"fa-chart-network"}
                        title={"Connect"}
                        showNew={appAppCode === 'BC' || appAppCode === 'MB'}
                    />
                }
            </Navbar>

            <Tab.Container activeKey={defaultKey}>
                <ListGroup>
                    <Nav
                        className="flex-column nav-file-content"
                        style={props.drawerState === fileTabVal.EMPTY ? { display: "none" } : {}} >
                        {menu.map(navItem(openMenu, drawerToggleMenu, 0))}
                    </Nav>
                </ListGroup>
            </Tab.Container>
        </>
    )
}